var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.valueIsDefined)?_c('assay-status-badge',{attrs:{"status":_vm.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }